module.exports = __webpack_public_path__ + "static/media/SG.5e652763.svg";